<template>
    <div>
        <el-table
            style="width: 100%"
            :data="economicGroups"
            :border="false"
            :cell-class-name="cellClassName"
        >

        <el-table-column min-width="100" class-name="pl-5">
            <template slot="header">
                Sacado
            </template>
            <template slot-scope="scope">
                <img
                    crossorigin="anonymous"
                    v-if="scope.row.logo"
                    :src="`${urlApi}/${scope.row.logo}`"
                    :alt="`${scope.row.name} image`"
                    class="economic-group-img ml-1"
                    @error="scope.row.logo=''"
                    @click="goToDetails(scope.row)"
                />
                <NameInitials v-else :name="scope.row.name" />
            </template>
        </el-table-column>

        <el-table-column min-width="100">
            <template slot-scope="scope">
                <h5 class="break d-block medium c-ndarkfour mb-0 ml-1" @click="goToDetails(scope.row)">
                    {{ scope.row.name | formatName }}
                </h5>
            </template>
        </el-table-column>

        <el-table-column min-width="80">
            <template slot="header">
                <div class="d-flex">
                    <span class="mr-1">Filiais</span>
                    </div>
                </template>
                <template slot-scope="scope">
                    <span class="mr-1 ml-1 medium c-ndarkfour" @click="goToDetails(scope.row)">
                        {{ scope.row.buyers.length }} filiais
                    </span>
                </template>
            </el-table-column>
            <el-table-column min-width="80">
                <template slot="header">
                    Local
                </template>
                <template slot-scope="scope">
                    <p class="bold c-ndarkfour ml-1" @click="goToDetails(scope.row)">
                        {{ scope.row.state.toUpperCase() }}
                    </p>
                </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="Início das..." min-width="80">
                <template slot="header">
                    <div>
                        <el-tooltip content="Início das operações" placement="top" >
                            <span>Início das...</span>
                        </el-tooltip>
                    </div>
                </template>
                <template slot-scope="scope">
                    <p class="medium c-ndarkfour ml-1" @click="goToDetails(scope.row)">
                        {{ scope.row.createdAt | formatDate }}
                    </p>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="totalValue" min-width="150">
                <template slot="header">
                    Total em notas
                </template>
                <template slot-scope="scope">
                    <p class="medium c-greenfour bold ml-1" @click="goToDetails(scope.row)">
                        R$ {{ scope.row.totalValue | formatMoney }}
                    </p>
                </template>
            </el-table-column> -->
            <el-table-column prop="orderFomentationRequest" min-width="80">
            <template slot-scope="scope">
                <el-dropdown trigger="click" >
                    <Button :color="getPrimaryColor" type="secondary" size="small">Ações</Button>
                    <el-dropdown-menu slot="dropdown">
                        <ActionBtnItemsContainer :withoutBottomLine="true">
                            <el-dropdown-item>
                                <el-dropdown placement="left-start" :show-timeout="0" class="d-flex">
                                    <span class="c-ndarkthree medium pl-3 pr-3 d-flex align-items-center">
                                        <CompanyIcon size="16" color="#A1A8B8" class="mr-1" />Classificar cadastro
                                        <ArrowDropdown class="ml-5" color="#A1A8B8" rotate="270"/>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="mt-n2">
                                        <el-dropdown-item>
                                            <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClassificationChange(scope.row, false)" :style="isRejected(scope.row) ? null : 'pointer-events: none;'">
                                                <CheckPayment size="18" color="#A1A8B8" :style="isRejected(scope.row) ? 'visibility: hidden;' : null" />
                                                <span class="ml-1">Aprovar</span>
                                            </span>
                                        </el-dropdown-item>
                                        <el-dropdown-item>
                                            <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="handleClassificationChange(scope.row, true)" :style="!isRejected(scope.row) ? null : 'pointer-events: none;'">
                                                <CheckPayment size="18" color="#A1A8B8" :style="!isRejected(scope.row) ? 'visibility: hidden;' : null" />
                                                <span class="ml-1">Reprovar</span>
                                            </span>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </el-dropdown-item>
                        </ActionBtnItemsContainer>
                        <ActionBtnItemsContainer v-if="$store.state.user.accessLevel" :withoutBottomLine="false"> 
                            <el-dropdown-item>
                                <span
                                    class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center"
                                    @click="dialogs.creditLimit = true; selectedEconomicGroupId = scope.row.id"
                                >
                                    <Money size="16" color="#A1A8B8" class="mr-2"/>Definir limite de crédito
                                </span>
                            </el-dropdown-item>
                        </ActionBtnItemsContainer>
                        <ActionBtnItemsContainer :withoutBottomLine="false">
                            <el-dropdown-item>
                                <span
                                    class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center"
                                    @click="handleZipDownload(scope.row)"
                                >
                                    <Download size="16" color="#A1A8B8" class="mr-2"/>Baixar todos documentos
                                </span>
                            </el-dropdown-item>
                        </ActionBtnItemsContainer>
                        <!-- <ActionBtnItemsContainer v-if="scope.row.economicGroupRule.modelOffers != 'manual'" :withoutBottomLine="true">
                            <el-dropdown-item>
                                <span
                                    class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center"
                                    @click="goToBuyersRule(scope.row)"
                                >
                                    <Buyers size="16" color="#A1A8B8" class="mr-2 svg-stroke"/>Propostas por sacado
                                </span>
                            </el-dropdown-item>
                        </ActionBtnItemsContainer>
                        <ActionBtnItemsContainer v-if="scope.row.economicGroupRule.modelOffers != 'manual'" :withoutBottomLine="false">
                            <el-dropdown-item>
                                <span
                                    class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center"
                                    @click="goToProviders(scope.row)"
                                >
                                    <Providers size="16" color="#A1A8B8" class="mr-2"/>Regras por cedente
                                </span>
                            </el-dropdown-item>
                        </ActionBtnItemsContainer> -->
                        <ActionBtnItemsContainer :withoutBottomLine="true">
                            <el-dropdown-item>
                                <span
                                    class="c-ndarkthree medium pl-3 pr-4 d-flex align-items-center"
                                    @click="goToDetails(scope.row)"
                                >
                                    <DetailsFile size="16" color="#A1A8B8" class="mr-2"/>Ver detalhes do sacado
                                </span>
                            </el-dropdown-item>
                        </ActionBtnItemsContainer>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
        </el-table-column>
        </el-table>
        <CreditLimit 
            :dialogVisible="dialogs.creditLimit" 
            @closeModal="dialogs.creditLimit = false" 
            :selectedEconomicGroupId="selectedEconomicGroupId" 
        />
    </div>
</template>

<script>

// Icons
import NameInitials from '@/components/icons/NameInitials'
import Download from '@/components/icons/Download'
// import Buyers from '@/components/icons/Buyers'
// import Providers from '@/components/icons/Assignor'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import CompanyIcon from '@/components/icons/Company'
import CheckPayment from '@/components/icons/CheckPayment'
import DetailsFile from '@/components/icons/DetailsFile'
import Money from '@/components/icons/Money'

// Requests
import getCompanyDocuments from '@/api/getCompanyDocuments'
import sendFilesToZip from '@/api/sendFilesToZip'
import updateRejectedEconomicGroup from '@/api/updateRejectedEconomicGroup'
import downloadArchive from '@/api/downloadArchive'

import ActionBtnItemsContainer from '@/components/container/ActionBtnItemsContainer'
import CreditLimit from '@/components/modals/CreditLimit.vue'

export default {
    props: {
        economicGroups: {
            required: true,
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {
            urlApi: process.env.VUE_APP_ROOT_API,
            dialogs: {
                creditLimit: false,
            },
            selectedEconomicGroupId: null,
        }
    },
    methods: {
        goToDetails(row) {
            this.$router.push(`buyers/${row.id}`)
        },
        // goToBuyersRule(row) {
        //     this.$router.push(`buyers/offerRules/${row.id}`)
        // },
        // goToProviders(row) {
        //     this.$router.push(`buyers/providers/${row.id}`)
        // }, 
        cellClassName({ columnIndex }) {
            let className = 'row-height'
            if (columnIndex == 0) {
                className += ' economic-group-table-first-cell'
            }

            return className
        },
        async getBuyersDocuments(economicGroup) {
            if (economicGroup.documents) {
                return economicGroup.documents
            }

            const documentsList = []
            
            await Promise.all(economicGroup.buyers.map(async (buyer) => {
                const documents = (await getCompanyDocuments(buyer.cnpjId)).data.payload
                const docsWithoutContracts = documents.filter((doc) => doc.docType != '0')
                documentsList.push(...docsWithoutContracts)
            }))
            
            if (documentsList.length) {
                this.$store.state.group.groups.map((group) => {
                    if (group.id == economicGroup.id) {
                        group.documents = documentsList
                    }
                    return group
                })
            }

            return documentsList
        },
        async handleZipDownload(row) {
            this.$store.commit('user/setIsDownloadLoading', true)
            const documentsList = await this.getBuyersDocuments(row)

            const zipPath = await sendFilesToZip(documentsList)
            await downloadArchive(`${process.env.VUE_APP_ROOT_API}/${zipPath}`)

            this.$store.commit('user/setIsDownloadLoading', false)
            setTimeout(() => {
                this.$notify({
                    title: 'Documentos baixados com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
            }, 500)
        },
        async handleClassificationChange(row, reject) {
            const notificationText = reject ? 'reprovado' : 'aprovado'
            
            const result = await updateRejectedEconomicGroup({
                economicGroupId: row.id, 
                sponsorCnpjId: this.$store.state.user.cnpjId,
                rejected: reject
            })
            
            if (result.ok) {
                this.$emit('classificationChange')
                this.$notify({
                    title: `Sacado ${notificationText} com sucesso.`,
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
            }
        },
        isRejected(scope){
            const [sponsor] = scope.sponsors

            return sponsor.economicGroupSponsor.rejected
        }
    },
    components: {
        NameInitials,
        Download,
        ArrowDropdown,
        CompanyIcon,
        CheckPayment,
        ActionBtnItemsContainer,
        DetailsFile,
        Money,
        CreditLimit,
        // Buyers,
        // Providers,
    },
}
</script>
<style lang="scss">
.economic-group-img {
    height: 36px!important;
    max-width: 60px !important;
    aspect-ratio: 3/2;
    object-fit: contain;
}

.economic-group-table-first-cell div {
    padding-left: 0px!important;
}

.row-height {
    height: 72px!important;
}

.without-line {
    border: 0px!important;
}

.c-ndarkthree .svg-stroke{
    stroke: none!important;
}
</style>